import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
    errorCode: number;
    errorMessage: string;
    hasShowError: boolean;
    constructor(
        public dialog: MatDialog,
        public translate: TranslateService,
        private spinner: NgxUiLoaderService,
    ) { }
    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            this.spinner.stopAll();
            // Backend returns unsuccessful response codes such as 404, 500 etc.
            console.error('Backend returned status code: ', error.status);
            console.error('Response body:', error.message);
            this.errorCode = error.status;
            switch (error.status) {
                case 0:
                    this.errorMessage = this.translate.instant('Errors.ConnectionFailed');
                    break;

                default:
                    this.errorMessage = error.message;
                    break;
            }
            if ((error.error)) {
                this.errorMessage = error.error.split('at')[0];
            }
            this.spinner.stopAll();
            if (!this.hasShowError) {
                this.hasShowError = true;
                const dialogRef = this.dialog.open(DialogComponent);
                dialogRef.componentInstance.title = this.translate.instant('MessageHeader.Error');
                dialogRef.componentInstance.hasCancel = true;
                dialogRef.componentInstance.message = `${this.errorMessage}`;
                dialogRef.afterClosed().subscribe(result => {
                    this.hasShowError = false;
                });
            }
            // throw(this.errorMessage);
        } else {
            // A client-side or network error occurred.
            console.error('An error occurred:', error.message);
            const err = error.message.toLowerCase();
            if (!err.includes('scrollintoview') && !err.includes('minposition') && !err.includes('maxposition') ) {
                this.spinner.stopAll();
                if (!this.hasShowError) {
                    this.hasShowError = true;
                    const dialogRef = this.dialog.open(DialogComponent);
                    dialogRef.componentInstance.title = this.translate.instant('MessageHeader.Error');
                    dialogRef.componentInstance.hasCancel = true;
                    dialogRef.componentInstance.hasOK = false;
                    dialogRef.componentInstance.message = `${error.message}`;
                    dialogRef.afterClosed().subscribe(result => {
                        this.hasShowError = false;
                    });
                }
            }
            // this.message.showMessage('',error.message);
        }
        this.spinner.stopAll();
    }
}
